/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forgot_PasswordInputs */

const en_forgot_password = /** @type {(inputs: Forgot_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forgot password?`)
};

const es_forgot_password = /** @type {(inputs: Forgot_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Olvidaste tu contraseña?`)
};

const fr_forgot_password = /** @type {(inputs: Forgot_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mot de passe oublié ?`)
};

const de_forgot_password = /** @type {(inputs: Forgot_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passwort vergessen?`)
};

const ja_forgot_password = /** @type {(inputs: Forgot_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パスワードをお忘れですか？`)
};

const zh_forgot_password = /** @type {(inputs: Forgot_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`忘记密码？`)
};

const ar_forgot_password = /** @type {(inputs: Forgot_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`هل نسيت كلمة المرور؟`)
};

const id_forgot_password = /** @type {(inputs: Forgot_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lupa kata sandi?`)
};

const it_forgot_password = /** @type {(inputs: Forgot_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Password dimenticata?`)
};

const ru_forgot_password = /** @type {(inputs: Forgot_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Забыли пароль?`)
};

const pt_forgot_password = /** @type {(inputs: Forgot_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esqueceu a senha?`)
};

const ko_forgot_password = /** @type {(inputs: Forgot_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`비밀번호를 잊으셨나요?`)
};

/**
* | output |
* | --- |
* | "Forgot password?" |
*
* @param {Forgot_PasswordInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const forgot_password = /** @type {((inputs?: Forgot_PasswordInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forgot_PasswordInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forgot_password(inputs)
	if (locale === "es") return es_forgot_password(inputs)
	if (locale === "fr") return fr_forgot_password(inputs)
	if (locale === "de") return de_forgot_password(inputs)
	if (locale === "ja") return ja_forgot_password(inputs)
	if (locale === "zh") return zh_forgot_password(inputs)
	if (locale === "ar") return ar_forgot_password(inputs)
	if (locale === "id") return id_forgot_password(inputs)
	if (locale === "it") return it_forgot_password(inputs)
	if (locale === "ru") return ru_forgot_password(inputs)
	if (locale === "pt") return pt_forgot_password(inputs)
	return ko_forgot_password(inputs)
});